module.exports = __webpack_public_path__ + "static/media/mBG8.4a29412f.jpg";